<section id="titulo-centrado" class="sect-cocteles-titles">
  <div class="container-page">
    <div [innerHTML]="config.bannerTitle"></div>
  </div>
</section>
<section id="coteles-swiper">
  <div class="container-page">
    <div class="swiper copas-swiper">
      <swiper [slidesPerView]="1" 
              [spaceBetween]="30" 
              [loop]="true" [pagination]="{clickable: true}" 
              [navigation]="true"
        class="mySwiper">
        <ng-container *ngFor="let slider of config.bannerSwipers; index as i">
          <ng-template swiperSlide>
            <div class="content-slider-copa">
              <div class="texto-copa">
                <div [innerHTML]="slider.productName"></div>
                <div *ngIf="slider.paragraph" [innerHTML]="slider.paragraph"></div>
                <a href="{{slider.buttonUrl}}" class="comienza azul">{{slider.buttonText}}</a>
              </div>
              <div class="img-copa">
                <img src="{{slider.image}}" alt="">
              </div>
            </div>
          </ng-template>
        </ng-container>
      </swiper>
    </div>
  </div>
</section>